module.exports = __webpack_public_path__ + "static/img/banner_sanming.a3d1dcb0.png";